var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconUpload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19995 12.5C1.19995 13.7703 2.2297 14.8 3.49995 14.8H12.5C13.7702 14.8 14.8 13.7703 14.8 12.5V11.4546C14.8 11.0128 14.4418 10.6546 14 10.6546C13.5581 10.6546 13.2 11.0128 13.2 11.4546V12.5C13.2 12.8866 12.8866 13.2 12.5 13.2H3.49995C3.11335 13.2 2.79995 12.8866 2.79995 12.5V11.4546C2.79995 11.0128 2.44178 10.6546 1.99995 10.6546C1.55812 10.6546 1.19995 11.0128 1.19995 11.4546V12.5ZM7.99995 11.3C8.44178 11.3 8.79995 10.9419 8.79995 10.5V4.26005L11.2239 6.37552C11.5568 6.66603 12.0622 6.63169 12.3527 6.2988C12.6432 5.96592 12.6089 5.46055 12.276 5.17004L8.52598 1.89731C8.22461 1.6343 7.77529 1.6343 7.47392 1.89731L3.72392 5.17004C3.39104 5.46055 3.35669 5.96592 3.64721 6.2988C3.93773 6.63169 4.44309 6.66603 4.77598 6.37552L7.19995 4.26005V10.5C7.19995 10.9419 7.55812 11.3 7.99995 11.3Z",
    fill: "#002CFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/iconUpload.4948218d1c220e6b95c11cc9dae26934.svg";
export { ForwardRef as ReactComponent };